export default function(value, parentValue = null) { //TODO: 현재는 key가 있는 경우만 처리 가능
  if (this.multiTooltip && this.multiTooltip()) return this;
  let condition = d => {
    let cond = true
    if (parentValue) cond = d.parent.data.key == parentValue;
    cond = cond && d.data.key == value;
    return cond;
  }
  let nodes = this.filterNodes(condition); 
  let tooltip = this.__execs__.tooltip;
  if (nodes.size() > 0) { //한개만 가능 
    nodes.each(function(d) {
      tooltip.showFromPoint(this, d);
    });
  }
  return this;
}


// WEBPACK FOOTER //
// ./layouts/default/showTooltip.js